// extracted by mini-css-extract-plugin
export default {"ConfirmPopup":"ConfirmPopup_ConfirmPopup__aQNUJ","Body":"ConfirmPopup_Body__uRAWV","Footer":"ConfirmPopup_Footer__MQ77x"};